import * as Environment from "../base/Environment.js";
import {RenderContext, Stage, AnimatableSprite} from "../base/Display2D.js";

import {Site} from "./Site.js";

//
// Navigation extends Stage
//

export const Navigation = function (context) {
	Stage.apply (this, arguments);
	
	if (Navigation.sharedInstance)
		throw new Error ("Cannot instantiate. Navigation is singleton.");
	
	Navigation.sharedInstance = this;
	
	var element = this.element;
	element.style.visibility = "";
	element.classList.remove ("sprite");
	element.classList.add ("unselectable");
	
	this.setUpContent ();
	
	this.addListener ("resize", this.resize, this);
	this.resize ();
	
	if (Environment.FAST_PASS) {
		/*
		window.setTimeout (function () {
			this.toggleMenu ();
			
		}.bind (this), 250);
		
		window.setTimeout (function () {
			this.toggleMenu ();
			
		}.bind (this), 1250);
		*/
		
	}
	
};

Navigation.prototype = Object.create (Stage.prototype);

Navigation.DEPTH = 1;

Navigation.prototype.setUpContent = function () {
	const element = this.element
	
	const mobileNavigation = this.mobileNavigation = element.parentNode.querySelector (".mobile-navigation");
	const mobileNavigationContent = mobileNavigation.firstElementChild.firstElementChild.firstElementChild;

	const mobileNavigationSeparator = this.mobileNavigationSeparator = document.createElement ("div");
	mobileNavigationSeparator.classList.add ("mobile-navigation--separator");
	mobileNavigation.appendChild (mobileNavigationSeparator);
	
	const mainNavigation = this.mainNavigation = element.querySelector (".main-navigation");
	mobileNavigationContent.appendChild (mainNavigation.cloneNode (true));
	
	
	const mainNavigationItems = this.mainNavigationItems = mainNavigation.parentNode.querySelectorAll (".main-navigation > ul > li");
	const clickNavigationItem = this.clickNavigationItem.bind (this);
	
	let activeItem;
	
	for (let i = mainNavigationItems.length; i--;) {
		const mainNavigationItem = mainNavigationItems [i];
		
		if (mainNavigationItem.classList.contains ("active")) {
			mainNavigationItem.classList.add ("open");
			activeItem = mainNavigationItem;
			
		}
		
		mainNavigationItem.addEventListener ("click", clickNavigationItem);
		
		const controller = mainNavigationItem.controller =
			this.attachSprite (Navigation.ItemController);
		controller.takeElement (mainNavigationItem);
		
	}
	
	if (activeItem) {
		window.setTimeout (function () {
			if (!Navigation.didToggle)
				activeItem.controller.toggleOpen (true);
			
		}, 2000);
		
	}
	
	document.body.addEventListener ("click", function (event) {
		let target = event.target;
		while (target) {
			if (target.classList && target.classList.contains ("header"))
				return;
			
			target = target.parentNode;
			
		}
		
		for (let i = mainNavigationItems.length; i--;) {
			const mainNavigationItem = mainNavigationItems [i];
			if (mainNavigationItem.classList.contains ("open"))
				mainNavigationItem.controller.toggleOpen (true);
			
		}
		
	}.bind (this));
	
	const mobileNavigationItems = this.mobileNavigationItems =
		mobileNavigation.querySelectorAll (".main-navigation > ul > li");
	const clickMobileNavigationItem = this.clickMobileNavigationItem.bind (this);
	
	for (let i = mobileNavigationItems.length; i--;) {
		const mobileNavigationItem = mobileNavigationItems [i];
		
		if (mobileNavigationItem.classList.contains ("active"))
			mobileNavigationItem.classList.add ("open");
		
		mobileNavigationItem.addEventListener ("click", clickMobileNavigationItem);
		
		const controller = mobileNavigationItem.controller =
			this.attachSprite (Navigation.MobileItemController);
		controller.takeElement (mobileNavigationItem);
		
	}
	
	if (Environment.FAST_PASS) {
		/*
		window.setTimeout (function () {
			this.clickNavigationItem ({currentTarget: mainNavigationItems [0]});
			
		}.bind (this), 150);
		
		window.setTimeout (function () {
			this.clickMobileNavigationItem ({currentTarget: mobileNavigationItems [1]});
			
		}.bind (this), 500);
		*/
		
	}
	
	const languageSwitch = element.querySelector (".page-tool-language");
	mobileNavigationContent.appendChild (languageSwitch.cloneNode (true));
	
	
	const menuButton = this.menuButton = element.querySelector (".page-tool-menu");
	menuButton.addEventListener ("click", this.toggleMenu.bind (this));
	
	
	const headerLogo = this.headerLogo = element.querySelector (".header--logo");
	const pageTools = this.pageTools = element.querySelector (".page-tools");
	
};

Navigation.prototype.resizeContext = function (context) {
	this.setSize (
		Environment.IS_TOUCH_DEVICE ?
			RenderContext.getViewportSize () :
			this.getRulerSize ()
		
	);
	
};

Navigation.prototype.resize = function (sender) {
	this.isResizing = true;
	
	var viewSize = this.viewSize = this.size;
	
	this.scroll ();
	
	this.isResizing = false;
	
};

Navigation.prototype.scroll = function (sender) {
	
};

Navigation.prototype.renderSelfInContext = function () {
	
};

Navigation.prototype.clickNavigationItem = function (event) {
	const clickedItem = event.currentTarget;
	
	if (clickedItem.classList.contains ("open")) {
		// clickedItem.classList.remove ("open");
		clickedItem.controller.toggleOpen (true);
		
	} else {
		const mainNavigationItems = this.mainNavigationItems;
		
		for (let i = mainNavigationItems.length; i--;) {
			const mainNavigationItem = mainNavigationItems [i];
			
			if (mainNavigationItem == clickedItem) {
				if (!mainNavigationItem.classList.contains ("open"))
					mainNavigationItem.controller.toggleOpen (true);
					
			} else {
				if (mainNavigationItem.classList.contains ("open"))
					mainNavigationItem.controller.toggleOpen (true);
				
			}
			
		}
		
	}
	
};

Navigation.prototype.clickMobileNavigationItem = function (event) {
	const clickedItem = event.currentTarget;
	
	clickedItem.controller.toggleOpen (!!event);
	
	/*
	if (clickedItem.classList.contains ("open")) {
		clickedItem.classList.remove ("open");
		
	} else {
		const mobileNavigationItems = this.mobileNavigationItems;
		
		for (let i = mobileNavigationItems.length; i--;) {
			const mobileNavigationItem = mobileNavigationItems [i];
			
			if (mobileNavigationItem == clickedItem)
				mobileNavigationItem.classList.add ("open");
			else
				mobileNavigationItem.classList.remove ("open");
			
		}
		
	}
	*/
	
};

Navigation.prototype.toggleMenu = function (event) {
	const isOpen = this.isOpen = !this.isOpen;
	
	const element = this.element;
	
	const mobileNavigation = this.mobileNavigation;
	mobileNavigation.style.display = "block";
	mobileNavigation.style.height = "";
	
	if (isOpen) {
		element.classList.add ("open");
		
		this.expandedHeight = mobileNavigation.offsetHeight;
		this.startAnimation ("Expansion", {direction: 1, rate: .04});
		
	} else {
		element.classList.remove ("open");
		
		this.expandedHeight = mobileNavigation.offsetHeight;
		this.startAnimation ("Expansion", {direction: 0, rate: .04});
		
	}
	
};

Navigation.prototype.animateExpansion = function () {
	const state = this.updatedState ("Expansion");
	let t = state.phase;
	
	const mobileNavigation = this.mobileNavigation;
	
	mobileNavigation.style.display = t == 0 ? "none" : "block";
	
	this.mobileNavigationSeparator.style.opacity = (t - .25) / (1 - .25);
	
	if (t == 0) {
		
	} else if (t < 1) {
		t = .5 - Math.cos (t * Math.PI) * .5;
		t = .5 - Math.cos (t * Math.PI) * .5;
		
		const height = Math.round (
			this.expandedHeight * t
			
		);
		
		mobileNavigation.style.overflow = "hidden";
		mobileNavigation.style.height = height + "px";
		
	} else {
		mobileNavigation.style.overflow = "";
		mobileNavigation.style.height = "";
		
	}
	
};

//
// Navigation.ItemController extends AnimatableSprite
//

Navigation.ItemController = function (context) {
	AnimatableSprite.apply (this, arguments);
	
}

Navigation.ItemController.prototype = Object.create (AnimatableSprite.prototype);

Navigation.ItemController.prototype.takeElement = function (element) {
	this.element.parentNode.removeChild (this.element);
	this.element = element;
	
	this.subMenu = element.querySelector ("ul");
	
};

Navigation.ItemController.prototype.toggleOpen = function (animated) {
	const element = this.element;
	const isOpen = !element.classList.contains ("open");
	
	if (isOpen)
		element.classList.add ("open");
	else
		element.classList.remove ("open");
	
	const subMenu = this.subMenu;
	
	subMenu.style.zIndex = isOpen ? Navigation.DEPTH++ : "";
	subMenu.style.height = "";
	subMenu.style.overflow = "hidden";
	subMenu.style.display = "block";
	
	this.expandedHeight = subMenu.offsetHeight;
	
	Navigation.didToggle = true;
	
	if (!this.states ["Expansion"])
		this.states ["Expansion"] = {phase: isOpen ? 0 : 1};
	
	this.startAnimation ("Expansion", {direction: isOpen ? 1 : 0, rate: animated ? .08 : .99});
	
};

Navigation.ItemController.prototype.animateExpansion = function () {
	const state = this.updatedState ("Expansion");
	let t = state.phase;
	t = .5 - Math.cos (Math.PI * t) * .5;
	
	const subMenu = this.subMenu;
	
	if (t == 0) {
		subMenu.style.display = "none";
		
	} else if (t < 1) {
		const height = Math.round (this.expandedHeight * t);
		subMenu.style.height = height + "px";
		subMenu.style.display = "block";
	
	} else {
		subMenu.style.height = "";
		subMenu.style.display = "block";
		
	}
	
};

//
// Navigation.MobileItemController extends AnimatableSprite
//

Navigation.MobileItemController = function (context) {
	AnimatableSprite.apply (this, arguments);
	
}

Navigation.MobileItemController.prototype = Object.create (AnimatableSprite.prototype);

Navigation.MobileItemController.prototype.takeElement = function (element) {
	this.element.parentNode.removeChild (this.element);
	this.element = element;
	
	this.subMenu = element.querySelector ("ul");
	
};

Navigation.MobileItemController.prototype.toggleOpen = function (animated) {
	const element = this.element;
	const isOpen = !element.classList.contains ("open");
	
	if (isOpen)
		element.classList.add ("open");
	else
		element.classList.remove ("open");
	
	const subMenu = this.subMenu;
	
	subMenu.style.height = "";
	subMenu.style.overflow = "hidden";
	subMenu.style.display = "block";
	
	this.expandedHeight = subMenu.offsetHeight;
	
	if (!this.states ["Expansion"])
		this.states ["Expansion"] = {phase: isOpen ? 0 : 1};
	
	this.startAnimation ("Expansion", {direction: isOpen ? 1 : 0, rate: animated ? .08 : .99});
	
};

Navigation.MobileItemController.prototype.animateExpansion = function () {
	const state = this.updatedState ("Expansion");
	let t = state.phase;
	t = .5 - Math.cos (Math.PI * t) * .5;
	
	const subMenu = this.subMenu;
	
	if (t == 0) {
		subMenu.style.display = "none";
		
	} else if (t < 1) {
		const height = Math.round (this.expandedHeight * t);
		subMenu.style.height = height + "px";
		subMenu.style.display = "block";
	
	} else {
		subMenu.style.height = "";
		subMenu.style.display = "block";
		
	}
	
};
